@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

%ValidationMessage {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  display: flex;
  column-gap: 0.5em;
}

.ValidationMessageValid {
  @extend %ValidationMessage;

  color: $color-secondary-green;
}

.ValidationMessageInvalid {
  @extend %ValidationMessage;

  color: $color-warning;
}

.NoInput {
  @extend %ValidationMessage;

  color: $theme-form-alert-info-icon;
}
